import SpamList from "./SpamList.vue";

export default SpamList;
